export interface TabData {
    route: string;
    url?: string;
    title: string;
    colorHex: string;
    description: string;
    descriptionAlt?: string;
}

export const tabDataEmpty: TabData = {
    route: '',
    url: undefined,
    title: '',
    colorHex: '#000000',
    description: ''
}

const aboutCopy = 'Founded in 2010, Uncanny Valley is a unique music and sound collective based in an historic, harbourside studio in Sydney, Australia. UV\'s services includes original screen composition and songwriting, licence track re-records and remixes, live vocalist and musician records, sound design and broadcast mixing. UV\'s credits range from artist releases to short form trailers, promos, TVCs and long form series, films and touring shows. Here are just some of the artists we are proud to have worked with...'
// const addressCopy = '<b>UV Studios:</b> The Vault Studios, Waterview Wharf Workshops 4/37 Nicholson Street, Balmain East, NSW 2041 Sydney Australia<br>M: +61 400 439 355'

const addressCopy = ''

export const tabDataDesktopArray: Array<TabData> = [
    {
        route: '/location',
        title: 'Home', 
        colorHex: '#B23AEE',
        description: 'Uncanny Valley is in residence at The Vault Studios (est.1981), situated on Wangal Country, Sydney Harbour, as part of the heritage Waterview Wharf Workshops creative precinct of Balmain East. Once the explosive store for the Adelaide Steamship Company at the turn of the last century, the studios were made famous by legendary producer Mark Moffat (Yothu Yindi \'Treaty\') and has captured some of Australia\'s most influential recording artists. With the best of vintage and modern recording equipment, Uncanny Valley proudly continues this tradition.'
    },{
        route: '/projects', 
        title: 'Projects', 
        colorHex: '#DFDC36',
        description: 'Uncanny Valley\'s award-winning portfolio of music and sound projects span over 15 years of working with Australia\'s most recognised TV networks, production companies, artists and brands. Proudly striving to help define the sound of the nation, UV\'s music has scored some of the most iconic Australian series, news, sports and lifestyle campaigns. The team\'s collective craft and passion for storytelling has gained international attention leading to collaborations all over the world.   '
    },{
        route: '/team',
        title: 'Team', 
        colorHex: '#FF4E00',
        description: 'Uncanny Valley is a unique collective of music artists, screen composers, song writers, sound designers and producers working collaborativley across all facets of the music industry. We believe in the power of music to bring people together and work with creatives near and far to pursue that goal every day. We also partner with academics and technologists on progressive installations, pushing boundaries to discover the future of music and sound.'
    },{
        route: '/about', 
        title: 'About', 
        colorHex: '#AADDE2',
        description: 
          '<p class="about-content">' + aboutCopy + '</p>',
        
        descriptionAlt: 
          '<p class="about-content mobile-only">' + aboutCopy + '</p>' +
          '<p class="about-services mobile-only">' +
            '<br class="mobile-only">' +
            '<b class="mobile-only">Services</b><br class="mobile-only">' +
            'Sonic branding<br>' +
            'Original music composition<br>' +
            'Songwriting<br>' +
            'Licence Track Re-records<br>' +
            'Remixes and supervision<br>' +
            'Musical Direction<br>' +
            'Sound Design<br>' +
            'Voice Over direction<br>' +
            'Broadcast Mixing<br class="mobile-only">' +
          '</p>'
    },
    
    // {
    //     route: '',
    //     url: 'https://memu.live/',
    //     title: 'MEMU', 
    //     colorHex: '#8F51DF',
    //     description: ''
    // }
]

export const tabDataMobileArray: Array<TabData> = tabDataDesktopArray

// Tab shown/highlighted on '/' (router maps '/' to LocationView)
export const defaultTabIndex = tabDataDesktopArray.findIndex(tabDat => tabDat.route === '/location')
